import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthExpiredError, getValidAccessToken } from './tokenRefreshService';
import { LoadingIcon } from './loading_icon';

const ProtectedRoute = ({ element, securityEnabled }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(null);
    useEffect(() => {
            if (securityEnabled === null) {
                // Still loading security status, do nothing
                return;
            }

            if (!securityEnabled) {
                // If security is disabled, allow access without authentication
                setIsAuthenticated(true);
                return;
            }
            const checkAuthentication = async () => {
                try {
                    await getValidAccessToken();
                    setIsAuthenticated(true);
                } catch (e) {
                    // A network/server hiccup is not a reason to drop the session: render the
                    // page and let the next request refresh the token once the API is reachable.
                    setIsAuthenticated(!(e instanceof AuthExpiredError));
                }
            };

        checkAuthentication();
    }, [securityEnabled]);

    if (securityEnabled === null || isAuthenticated === null) {
        // Show loading spinner while checking authentication
        return<LoadingIcon state={true} height={'10rem'} />
    }

    if (!isAuthenticated) {
        // Clear tokens and redirect to login
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        // Redirect to login if not authenticated
        return <Navigate to="/login" replace />;
    }

    // Render the requested component if authenticated
    return element;
};

export default ProtectedRoute;
